import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap, tap } from 'rxjs/operators';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IntegrationMDMPairingService, PairChallenge } from '@era/locations-sdk';
import { EnvironmentService } from '@methylium/core';
import { PairConfirmContainerActions, PairingApiActions } from './pairing.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class PairingEffects {
  constructor(
    private pairingService: IntegrationMDMPairingService,
    private readonly environmentService: EnvironmentService,
    private readonly actions$: Actions,
    private readonly httpClient: HttpClient
  ) {}

  verifyCodeRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PairConfirmContainerActions.verifyCodeRequested),
      mergeMap(({ code }) => {
        if (this.environmentService.environment.local) {
          const url = new URL(this.pairingService.configuration.basePath);
          url.hostname = window.location.hostname;
          this.pairingService = new IntegrationMDMPairingService(
            this.httpClient,
            url.origin,
            this.pairingService.configuration
          );
        }

        return safeMap(
          this.pairingService.verifyPairCode(code),
          (pairChallenge: PairChallenge) => PairingApiActions.verifyCodeValid({ pairChallenge }),
          (httpErrorResponse: HttpErrorResponse) => {
            if (httpErrorResponse.error?.error?.innerError?.code === 'InvalidToken') {
              return PairingApiActions.verifyCodeInvalid();
            } else {
              return PairingApiActions.verifyCodeError({ error: httpErrorResponse });
            }
          }
        );
      })
    );
  });

  enrollmentRequestedEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(PairConfirmContainerActions.enrollmentRequested),
        tap(({ challenge }) => {
          if (this.environmentService.environment.local) {
            const url = new URL(`${this.environmentService.environment.mdm.enrollUrl as string}/${challenge}`);
            url.hostname = window.location.hostname;
            window.location.href = url.toString();
          } else {
            window.location.href = `${this.environmentService.environment.mdm.enrollUrl as string}/${challenge}`;
          }
        })
      );
    },
    { dispatch: false }
  );
}
